<script>
	import { Input } from 'element-ui';

	export default {
		registryName: 'number-input',

		mixins: [Input],

		props: {
			min: { //可输入的最小值
				type: [Number, String],
				default: -Infinity
			},

			max: { //可输入的最大值
				type: [Number, String],
				default: Infinity
			},

			integer: Boolean, //是否只能输入整数

			notEmpty: Boolean, //不允许空值
		},

		mounted (){
			this._preValue = this.getInput().value;
		},

		methods: {
			handleBlur(event) {
				this.focused = false;

				if(this.notEmpty && ['', null, undefined].includes(event.target.value)){
					event.target.value = this.min < 0 ? 0 : this.min;

					this.$emit('input', event.target.value);
					this.$nextTick(function () {
						this.setNativeInputValue();

						_handleBlur.call(this);
					});
				}else{
					_handleBlur.call(this);
				}

				function _handleBlur() {
					this.$emit('blur', event);
					if (this.validateEvent) {
						this.dispatch('ElFormItem', 'el.form.blur', [this.value]);
					}
				}
			},

			handleInput(event) {
				if (this.isComposing) return;

				if (event.target.value === this.nativeInputValue) return;

				let { min, max } = this, value = event.target.value;

				if(value !== '-' && !value.endsWith('\.') && isNaN(value)){
					value = this._preValue;
				}else if(['', undefined, null].includes(value)){
					value = undefined;
				}else{
					if(value < Number(min)){
						value = min;
					}else if(value > Number(max)){
						value = max;
					}
				}
				this.$emit('input', value);
				this.$nextTick(this.setNativeInputValue);
				this._preValue = value;
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/NumberInput.vue